export default {
      id: "furniture-usage",
      viewBox: "0 0 74.79 61.33",
      url: __webpack_public_path__ + "svgs/icons.91fe9319.svg#furniture",
      toString: function () {
        return this.url;
      }
    }